// import { generateTimeBlocks } from '@/api/HardwareApi/WM/TaskTimeBlocksUtil';
import { encrypt } from '@/tool/crypto';
import { getProfile, getSystemCode, getDistlic } from '@/tool/profile';

// eslint-disable-next-line import/no-cycle
import { client } from './index';

const keyboxTopics = {
  KEYBOX_LIST: '/vanma/keybox/+/recovery',
  KEYBOX_REPORT_OVER: '/vanma/keybox/+/giveback/node/+', // 钥匙数据读取完毕通知
};

const handler = {
  onRecovery: null,
};

// 仅调试使用
// 模拟钥匙盒数据，以避免每次启动都要等30s才能获取到数据
export const initialMockKeybox = {
  // id 钥匙柜id
  // name 钥匙柜名称
  // nodeId 钥匙孔ID
  // keyId 钥匙ID
  // status 钥匙孔状态，0 无钥匙,1有钥匙
  // keyType 钥匙类别, 0 c钥匙,1 其他钥匙
  data: [
    { device: 0, keyId: '', keyType: 0, nodeId: 1, protocol: 0, status: 0 },
    { device: 0, keyId: '', keyType: 0, nodeId: 2, protocol: 0, status: 0 },
    { device: 0, keyId: '123456789001', keyType: 0, nodeId: 3, protocol: 0, status: 1 },
    { device: 0, keyId: '', keyType: 0, nodeId: 4, protocol: 0, status: 0 },
    { device: 0, keyId: '', keyType: 0, nodeId: 5, protocol: 0, status: 0 },
    { device: 0, keyId: '000000000001', keyType: 0, nodeId: 6, protocol: 0, status: 1 },
    { device: 0, keyId: '000000000002', keyType: 0, nodeId: 7, protocol: 0, status: 1 },
    { device: 0, keyId: '', keyType: 0, nodeId: 8, protocol: 0, status: 0 },
    { device: 0, keyId: '', keyType: 0, nodeId: 9, protocol: 0, status: 0 },
    { device: 0, keyId: '', keyType: 0, nodeId: 10, protocol: 0, status: 0 },
  ],
  name: '测试钥匙盒',
  id: '64:83:fb:91:d8:fd',
};

const getKeyboxToken = () =>
  encrypt(
    JSON.stringify({
      key: getSystemCode(),
      sign: getProfile().overseas ? 1 : 0,
      lic: getDistlic(),
    })
  );

export const keyboxMiddleware = (topic, payload) => {
  // 钥匙柜发现事件，定于时使用+通配符，但返回时返回的是真实id
  if (topic.endsWith('recovery')) {
    handler.onRecovery(payload);
  } else if (handler[topic]) {
    handler[topic](payload);
    handler[topic] = null;
    delete handler[topic];
    client.unsubscribe(topic);
  }
};

// 获取钥匙盒列表，理论上此监听不需要前台进行处理，后台监听然后实时更新数据库即可
export const subscribeKeybox = callback => {
  client.subscribe(keyboxTopics.KEYBOX_LIST, err => {
    console.log('mqtt add', 'KEYBOX_LIST', err);
    if (!err) handler.onRecovery = callback;
    else console.warn(err);
  });
};

export const unsubscribeKeybox = () => {
  client.unsubscribe(keyboxTopics.KEYBOX_LIST, err => {
    console.log('mqtt remove', 'KEYBOX_LIST', err);
    if (!err) handler.onRecovery = null;
    else console.warn(err);
  });
};

// 钥匙数据读取完毕通知
export const subscribeReportOver = () => {
  client.subscribe(keyboxTopics.KEYBOX_REPORT_OVER);
};
export const unsubscribeReportOver = () => {
  client.unsubscribe(keyboxTopics.KEYBOX_REPORT_OVER);
};

//  领出
export const authKey = (
  keyboxId,
  nodeId,
  time,
  fingers,
  {
    taskId,
    timeBlocks,

    // beginDate,
    // endDate,
    // timeRanges,
    locksList,
    offline,
    // , passwords,
    // TODO: 指纹钥匙暂时不予支持，后续支持；
    // eslint-disable-next-line no-unused-vars
    characteristics,
  },
  callback
) => {
  const topic = `/vanma/keybox/${keyboxId}/auth/node/${nodeId.toString()}`;
  // const timeBlocks = generateTimeBlocks(beginDate, endDate, timeRanges, locksList, offline);
  console.log('钥匙盒下载的任务时段');
  console.log(timeBlocks);
  console.warn(topic, getKeyboxToken());
  const param = {
    nodeId,
    token: getKeyboxToken(),
    time,
    data: {
      taskId,
      offline,
      lockIds: locksList,
      timeBlocks,
      // [
      //   {
      //     from: beginDate,
      //     to: endDate,
      //     times: timeRanges.map(range => ({
      //       from: range[0],
      //       to: range[1],
      //     })),
      //   },
      // ],
      // 如果为指纹钥匙，并且需要下载指纹，则填充 fingers
      fingers,
    },
  };
  console.log('发布参数', param);
  const reponseTopic = `/vanma/keybox/${keyboxId}/auth/node/+/response`;
  // 订阅授权回复主题
  client.subscribe(reponseTopic, () => {
    // if(!err)
    nodeId.forEach(node => {
      const tmpTopic = `/vanma/keybox/${keyboxId}/auth/node/${node}/response`;
      handler[tmpTopic] = callback;
    });
  });
  client.publish(
    // topic
    topic,
    // message
    JSON.stringify(param),
    // option
    {},
    // callback
    err => {
      if (err) console.warn(err);
    }
  );
};
//  应急钥匙
export const emergencyKey = (keyboxId, nodeId, time, { beginTime, endTime }, callback) => {
  const topic = `/vanma/keybox/${keyboxId}/emergency/node/${nodeId.toString()}`;
  console.warn(topic, getKeyboxToken());

  const param = {
    nodeId,
    token: getKeyboxToken(),
    time,
    data: {
      from: beginTime,
      to: endTime,
    },
  };
  console.log('emergencyKey param', param);
  const reponseTopic = `/vanma/keybox/${keyboxId}/emergency/node/+/response`;
  // 订阅授权回复主题
  client.subscribe(reponseTopic, () => {
    // if(!err)
    nodeId.forEach(node => {
      const tmpTopic = `/vanma/keybox/${keyboxId}/emergency/node/${node}/response`;
      handler[tmpTopic] = callback;
    });
  });
  client.publish(
    // topic
    topic,
    // message
    JSON.stringify(param),
    // option
    {},
    // callback
    err => {
      if (err) console.warn(err);
    }
  );
};
//  弹出
export const ejectKey = (keyboxId, nodeId) => {
  const topic = `/vanma/keybox/${keyboxId}/eject/node/${nodeId.toString()}`;
  console.log('topic', topic);
  // 弹出钥匙没有响应
  client.publish(
    // topic
    topic,
    // message
    JSON.stringify({
      nodeId,
    }),
    // option
    {},
    // callback
    err => {
      if (err) console.warn(err);
    }
  );
};
